import { CHANNEL_TYPE_ICON_MAP } from '@/utils/channel.constants'

/**
 * Format integration type string from snake_case to Title Case
 * @param {string} type - Integration type (e.g., 'email_helpdesk')
 * @returns {string} Formatted type (e.g., 'Email')
 */
export function formatIntegrationType(type) {
  if (!type) return 'Unknown'
  // Special case for email_helpdesk to display as "Email"
  if (type === 'email_helpdesk') {
    return 'Email'
  }
  if (type === 'daktela') {
    return 'Daktela Chat'
  }

  return type.split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

/**
 * Normalize a Daktela instance URL: trim, add https:// when the scheme is missing,
 * and strip trailing slashes.
 * @param {string} url
 * @returns {string}
 */
export function normalizeDaktelaUrl(url) {
  if (url == null) return ''
  let normalized = String(url).trim()
  if (!normalized) return ''
  if (!normalized.includes('://')) {
    normalized = `https://${normalized}`
  }
  return normalized.replace(/\/+$/, '')
}

/**
 * Enrich channels array with icon property based on channel type
 * @param {Array} channels - Array of channel objects
 * @returns {Array} Channels with icon property added
 */
export function enrichChannelsWithIcons(channels) {
  return channels?.map(channel => ({
    ...channel,
    icon: CHANNEL_TYPE_ICON_MAP[channel.type]
  })) || []
}

/**
 * Enrich integration object with channel icons
 * @param {Object} integration - Integration object
 * @returns {Object} Integration with enriched channels
 */
export function addIconsToIntegrationChannels(integration) {
  return {
    ...integration,
    channels: enrichChannelsWithIcons(integration.channels)
  }
}

